export const getConnectedSchool = state => state.auth.connectedSchool
export const getAccessToken = state => state.auth.accessToken
